import React from 'react';
import './HeroSection.css';
import { useNavigate } from 'react-router-dom';


const HRCopilotHero = () => {
    const navigate = useNavigate();
      const handleRecruit = () => navigate('/access-recruit');

  return (
    <div className="hrh-hero-container">
      <div className="hrh-hero-content">
        {/* Header Badge */}
        <div className="hrh-badge">
          <span className="hrh-heart-icon">❤️</span>
          <span>ALL-IN-ONE HR, HIRING AND ONBOARDING</span>
        </div>
        
        {/* Main Title */}
        <h1 className="hrh-main-title">
          <span className="hrh-loved-text">Loved</span> by people.  <span className="hrh-loved-text">Built</span> for growth.
        </h1>
        
        {/* Description */}
        <p className="hrh-description">
          The AI-powered platform that's easy to use and fast to scale.
        </p>
        
        {/* CTA Buttons */}
        <div className="hrh-cta-buttons">
          <button className="hrh-btn hrh-btn-primary" onClick={handleRecruit}>
            REQUEST A DEMO
          </button>
          <button className="hrh-btn hrh-btn-secondary" onClick={handleRecruit}>
            TAKE A TOUR
          </button>
        </div>
        
        {/* Stats Section */}
        <div className="hrh-stats-section">
          <p className="hrh-stats-text">
            Join <span className="hrh-stats-number">4,500+</span> companies and{' '}
            <span className="hrh-stats-number hrh-bordered">804,011</span> people using HR Copilot right now.
          </p>
        </div>
        
        {/* Company Logos */}
        <div className="hrh-companies">
          <div className="hrh-company-logo">TechCorp</div>
          <div className="hrh-company-logo">InnovateLabs</div>
          <div className="hrh-company-logo">GlobalTech</div>
          <div className="hrh-company-logo">SmartSoft</div>
          <div className="hrh-company-logo">CloudWorks</div>
          <div className="hrh-company-logo">DataFlow</div>
          <div className="hrh-company-logo">NextGen</div>
          <div className="hrh-company-logo">ProSystems</div>
        </div>
        
        {/* Video Section */}
        <div className="hrh-video-section">
          <div className="hrh-video-container">
            <video 
              className="hrh-video"
              autoPlay 
              loop 
              muted 
              playsInline
            >
              <source 
                src="/images/vido4.mp4" 
                type="video/mp4" 
              />
            </video>
            
            {/* Floating Cards */}
            <div className="hrh-floating-card hrh-card-training">
              <div className="hrh-card-video-thumb">
                <div className="hrh-play-button">▶</div>
              </div>
              <div className="hrh-card-info">
                <div className="hrh-card-title">Training</div>
                <div className="hrh-progress-bar">
                  <div className="hrh-progress-fill"></div>
                </div>
                <div className="hrh-progress-info">
                  <span>20%</span>
                  <span>22m</span>
                </div>
              </div>
            </div>
            
            <div className="hrh-floating-card hrh-card-satisfaction">
              <div className="hrh-emoji-icon">😊</div>
              <div className="hrh-satisfaction-score">5</div>
            </div>
            
            <div className="hrh-floating-card hrh-card-employee">
              <img 
                src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop" 
                alt="Employee" 
                className="hrh-employee-image"
              />
            </div>
            
            <div className="hrh-floating-card hrh-card-notification">
              <div className="hrh-notification-dot"></div>
              <div className="hrh-notification-text">New Update</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HRCopilotHero;